import { Component, Input, Output, EventEmitter, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatStepper } from '@angular/material/stepper';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { NavigationService } from '../../services/navigation.service';
import { IPageDetails } from '../../data/page-details';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit, OnDestroy {
  @Input() selectedForm!: IPageDetails;
  @Input() showOptions: boolean = false;
  
  @Output() onOptions = new EventEmitter<void>();
  @ViewChild('stepper') stepper!: MatStepper;

  private destroy$ = new Subject<void>();
  isHandset$: Observable<boolean>;
  stepperOrientation: 'horizontal' | 'vertical' = 'horizontal';

  constructor(
    private navigationService: NavigationService,
    private router: Router,
    private breakpointObserver: BreakpointObserver
  ) {
    this.isHandset$ = this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.Small])
      .pipe(map(result => result.matches));
  }

  ngOnInit() {
    // Subscribe to breakpoint changes to update stepper orientation
    this.isHandset$.pipe(takeUntil(this.destroy$)).subscribe(isHandset => {
      this.stepperOrientation = isHandset ? 'vertical' : 'horizontal';
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get currentStepIndex(): number {
    const currentPage = this.getCurrentPageFromRoute();
    return this.selectedForm ? this.navigationService.getPageIndex(currentPage) : 0;
  }

  private getCurrentPageFromRoute(): string {
    const urlSegments = this.router.url.split('/');
    return urlSegments[urlSegments.length - 1] || '';
  }

  isStepCompleted(index: number): boolean {
    return index < this.currentStepIndex;
  }


  private goToPage(page: string): void {
    const pageIndex = this.selectedForm.pages.indexOf(page);
    this.navigationService.navigateToPage(pageIndex);
  }

  optionsClicked(): void {
    this.onOptions.emit();
  }

  getStepLabel(page: string): string {
    // Convert page names to user-friendly labels
    return page.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  }
}